import React, { useState } from "react";
import styled from "styled-components";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import media from "responsive";
import CategoryButtons from "components/Menu/CategoryButtons";
import CategoryRenderer from "components/Menu/CategoryRenderer";
import { useMenuData } from "hooks/useMenuData";
import { useMenuClick } from "hooks/useMenuClick";

export default function Menu() {
  const { menuItems, categories } = useMenuData();
  const { selectedMenuItem, handleMenuClick, setSelectedMenuItem } =
    useMenuClick();

  // Category selection state (null means show all categories)
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const handleCategoryClick = (categoryId) => {
    setSelectedCategoryId(categoryId);
    window.scrollTo({ top: 650, behavior: "smooth" });
  };

  const getFilteredItems = (categoryId) => {
    return menuItems.filter((item) => item.categoryId === categoryId);
  };

  // Render a single category block
  const renderCategoryBlock = (category) => (
    <CategoryBlock key={category.id}>
      <CategoryTitle>{category.name}</CategoryTitle>
      <Subtitle>
        <i>Extra Charge for Substitutions</i>
        {category.subtitle && <Additional>{category.subtitle}</Additional>}
      </Subtitle>
      <MenuItemsContainer>
        <CategoryRenderer
          category={category}
          items={getFilteredItems(category.id)}
        />
      </MenuItemsContainer>
    </CategoryBlock>
  );

  return (
    <Container>
      <Navbar
        selectedMenuItem={selectedMenuItem}
        handleMenuClick={handleMenuClick}
        setSelectedMenuItem={setSelectedMenuItem}
      />
      <CategoryButtons
        categories={categories}
        selectedCategoryId={selectedCategoryId}
        setSelectedCategoryId={setSelectedCategoryId}
        handleCategoryClick={handleCategoryClick}
      />
      <MenuContainer>
        {selectedCategoryId === null
          ? categories.map(renderCategoryBlock)
          : (() => {
              const category = categories.find(
                (c) => c.id === selectedCategoryId
              );
              return category ? renderCategoryBlock(category) : null;
            })()}
      </MenuContainer>

      <Footer
        selectedMenuItem={selectedMenuItem}
        handleMenuClick={handleMenuClick}
      />
    </Container>
  );
}

const Container = styled.div`
  background-color: #f5f5f5;
`;

const MenuContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 90px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${media.tabletL`
    padding: 20px 1px;
    `}

  ${media.tablet`

    padding-top: 10px;
    padding-bottom: 0px;
    `}

    ${media.mobileL`
   
    padding-top: 10px;
    padding-bottom: 0px;
  
  `}

  ${media.galaxyFold`
    padding-top: 10px;
    padding-bottom: 0px;
  `}
`;

const CategoryBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  padding: 0 30px;

  ${media.mobileL`
    padding: 0 10px;
    margin-bottom: 30px;
  `}
`;

const Subtitle = styled.div`
  font-size: 1em;
  text-align: left;
  font-weight: semi-bold;
  margin-bottom: 50px;
  padding-bottom: 15px;
  ${media.mobileL`
  padding-bottom: 0px;
    margin-bottom: 10px;
    font-size: 0.8em;
  `}
`;

const Additional = styled.div`
  font-size: 1em;
  text-align: left;
  font-weight: semi-bold;
  margin-bottom: 10px;
  padding-top: 10px;
`;

const CategoryTitle = styled.h2`
  font-size: 2.4em;
  text-align: left;
  margin-bottom: 10px;
  font-weight: bold;

  ${media.mobileL`
    font-size: 1.4em;
  `}

  ${media.galaxyFold`
    font-size: 1em;
  `}
`;

const MenuItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap; // This ensures the menu items move to the next line if there's not enough space
  justify-content: space-between;
`;
